import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import shop from './modules/shop'
import anchor from './modules/anchor'
import business from './modules/business'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  getters,
  modules: {
    user,
    anchor,
    shop,
    business,
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js